export default __webpack_public_path__ + "static/media/kitchen3-after3-480w.b6c56b3c.avif";